import { baseApi, storefrontPath } from '../services/baseApi'
import type { Bootstrap } from '../types/storefront'

export const bootstrapApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getBootstrap: build.query<Bootstrap, string>({
      query: (slug) => storefrontPath(slug, '/bootstrap'),
      providesTags: ['Bootstrap'],
    }),
  }),
})

export const { useGetBootstrapQuery } = bootstrapApi
